import React from 'react';
import ReactDOM from 'react-dom';
import PaymentForm from './components/PaymentForm';

window.loadPaymentForm = (containerId, onSuccess) => {
  const container = document.getElementById(containerId);
  if (container) {
    ReactDOM.render(<PaymentForm onSuccess={onSuccess} />, container);
  }
};
